export default "__VITE_ASSET__C3i$srs4__"